<template>
  <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user">
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ options.fullName }}
         
        </p>
      </div>

      <b-avatar
        size="40"
        :src="options.imageUrl"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon v-if="!options.imageUrl" icon="UserIcon" size="22" />
      </b-avatar>
    </template>

    <!-- <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MailIcon"
        class="mr-50"
      />
      <span>Inbox</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'misc-coming-soon' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CheckSquareIcon"
        class="mr-50"
      />
      <span>Task</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'misc-coming-soon' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MessageSquareIcon"
        class="mr-50"
      />
      <span>Chat</span>
    </b-dropdown-item> -->

    <b-dropdown-item :to="{ name: 'pages-account-setting' }" link-class="d-flex align-items-center">
      <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
      <span>Settings</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>Logout</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import api from "@/api/api-v1-config";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      //userData: JSON.parse(localStorage.getItem("userData")),
      userData: null,
      avatarText,
      // options: [],
      options: {
      fullName: '',
      imageUrl: '',
    },
      token: localStorage.getItem("accessToken"),
    };
  },
  mounted() {
    // this.options.fullName = this.userData.fullName;
    // const url = process.env.VUE_APP_MAIN_URL.replace('api/v1/','');
    // this.options.imageUrl = url + this.userData.imageUrl;
    this.loadUserData();
  },
  methods: {

   

    clearCache() {
      caches.keys().then(function (keys) {
        keys.forEach(function (key) {
          caches.delete(key);
        });
      });
    },

    loadUserData() {
    const stored = localStorage.getItem("userData");
    if (stored) {
      try {
        const userData = JSON.parse(stored);
        const url = process.env.VUE_APP_MAIN_URL.replace('api/v1/', '');
        this.options.fullName = userData.fullName || '';
        this.options.imageUrl = userData.imageUrl ? url + userData.imageUrl : '';
      } catch (e) {
        console.error("Invalid user data:", e);
        this.options.fullName = '';
        this.options.imageUrl = '';
      }
    } else {
      // Clear display if userData no longer exists
      this.options.fullName = '';
      this.options.imageUrl = '';
    }
  },

    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.clear();
      sessionStorage.clear();
      this.clearCache();

      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

      // Remove userData from localStorage
      localStorage.removeItem("userData");

      // Reset ability
      this.$ability.update(initialAbility);

      // Redirect to login page
      //this.$router.push({ name: "auth-login" });
      this.$router.push({ name: "auth-login" }).then(() => {
    window.location.reload(); // clears all component instances and memory
  });
    },
  },
};
</script>
